import {sendRequest} from "./Sender";

export const EventsService = {
    GetList,
    Create,
    GetById,
    Delete,
    Update
}

function GetList(params= [], expand = ''){
    return sendRequest('events', 'GET', {...params, 'expand': expand}, true)
}

function Create(data){
    return sendRequest('events', 'POST', data, true)
}

function GetById(id, expand = ''){
    return sendRequest('events/'  + id, 'GET', {'expand': expand}, true)
}

function Delete(id){
    return sendRequest('events/' + id, 'DELETE', {}, true)
}
function Update(id, data){
    return sendRequest('events/' + id, 'PUT', {...data}, true)
}